<template>
    <div>
        <v-card elevation="0" class="pa-3 mb-3">
            <v-select outlined :items="fileTypes" label="Tipo de arquivo exigido" v-model="form.type" item-value="value"
                item-text="text"></v-select>
            <template v-if="!loading">
                <template v-for="(limit, i) in form.limits">
                    <div v-if="i == 'types'" :key="i">
                        <v-select outlined label="Tipos de arquivos" :items="mimes" multiple
                            v-model="form.limits.types"></v-select>
                    </div>
                    <template v-else>
                        <div :key="`i-${i}`" v-if="i == 'dimensions'">
                            <label>Dimensões do arquivo (em pixels)</label>
                            <div class="d-flex">
                                <v-text-field outlined v-model="form.limits.dimensions.width" label="Largura" class="mr-1"></v-text-field>
                                <v-text-field outlined v-model="form.limits.dimensions.height" label="Altura" class="ml-1"></v-text-field>
                            </div>
                        </div>
                        <v-text-field outlined :key="`e-${i}`" v-else :label="objectModels[i].title"
                            v-model="form.limits[i]"></v-text-field>
                    </template>
                </template>
            </template>

        </v-card>
    </div>
</template>
<script>
export default {
    props: {
        snap: Object
    },
    data: () => ({
        loading: false,
        mimes: [],
        fileTypes: [
            {
                text: "Áudio",
                value: "audio",
                allowedMimes: ["audio/mpeg", "audio/ogg", "size"],
                allowedAttributes: ["types", "duration", "size"],
            },
            {
                text: "Imagem",
                value: "image",
                allowedMimes: ["image/png", "image/gif", "image/jpg", "image/*"],
                allowedAttributes: ["types", "dimensions", "size"]
            },
            {
                text: "Texto",
                value: "text",
                allowedMimes: ["application/pdf", "x-pdf", "application/msword", "application/vnd.openxmlformats-officedocument.wordprocessingml.document", "text/plain"],
                allowedAttributes: ["types", "size"]

            },
            {
                text: "Video",
                value: "video",
                allowedMimes: ["video/mp4", "video/mov", "video/wmv", "video/avi"],
                allowedAttributes: ["types", "duration", "dimensions", "framesPerSeconds", "size"],
            },
            
        ],
        form: {
            type: "",
            limits: []
        },
        objectModels: {
            types: {
                model: [],
                type: 'Array',
            },
            size: {
                model: 0,
                type: 'Number',
                title: 'Limite de comprimento de arquivo (em megabytes - MB)'
            },
            framesPerSeconds: {
                model: 0,
                type: 'Number',
                title: 'FPS (quadros por segundo)'
            },
            duration: {
                model: 0,
                type: 'Number',
                title: 'Duração (em segundos)'
            },
            dimensions: {
                model: {
                    width: 0,
                    height: 0
                },
                type: 'Object',
                title: 'Dimensões (Largura x Altura em pixels)'
            }
        }
    }),
    mounted() {
        this.form = JSON.parse(JSON.stringify(this.snap))
    },
    watch: {
        'form.type': {
            deep: true,
            handler(v) {
                if (v) {
                    // this.loading = true
                    let objs = this.fileTypes.filter(file => file.value == v)
                    this.form.limits = {}
                    if (objs.length) {
                        const obj = objs[0]
                        this.mimes = obj.allowedMimes
                        obj.allowedAttributes.forEach((item) => {
                            console.log('ITEM ALL', item)
                            this.form.limits[item] = this.objectModels[item].model
                        })
                        if (this.form.limits.hasOwnProperty('types')) {
                            this.form.limits.types = this.mimes
                        }
                    }
                    // setTimeout(() => {
                        // this.loading = false
                    // }, 1000)
                }
            }

        },
        'form': {
            deep: true,
            handler(v){
                this.$emit('update-specs', v)
            }
        }
    },
    methods: {
        eessage(c) {
            alert(c)
            console.log('eessage', c)
        }
    }
}
</script>